import NextImage, { ImageProps as NextImageProps } from 'next/image';

interface ImageProps extends Omit<NextImageProps, 'quality'> {
  quality?: number;
}

/**
 * Wrapper around Next.js Image component with quality={100} as default
 * This ensures all images use maximum quality globally
 */
export default function Image({ quality = 100, ...props }: ImageProps) {
  return <NextImage quality={quality} {...props} />;
}

